













import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ITimeSpanExpressionBehavior, TimeSpanKinds, ILinkedObjectSpecifiable } from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { FormatObjectSelectorColumnTypes } from "../../../../../formatEditor/components/format/editors/contents/commonComponents/selectors";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";
import { DateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";

@Component({
  components: {
    OptionDropDownSelector,
  }
})
export default class TimeSpanExpressionBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (write: (source: ITimeSpanExpressionBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITimeSpanExpressionBehavior) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get kind(): TimeSpanKinds {
    return this.readPropertyOrDefault(s => s.kind, TimeSpanKinds.DayHourMinute);
  }

  set kind(value: TimeSpanKinds) {
    this.writePropertyWhenValid(s => s.kind = value);
  }

  get from(): ILinkedObjectSpecifiable {
    return this.readPropertyOrDefault(s => s.from, null);
  }

  get to(): ILinkedObjectSpecifiable {
    return this.readPropertyOrDefault(s => s.to, null);
  }

  get selectionObjects(): ILinkedObjectSpecifiable[] {
    return Enumerable.from(this.commonComponents.currentPage.getObjects())
      .select(o => o instanceof DateObjectEditor ? o : null)
      .where(o => !!o && !o.isDate().getValue())
      .select(o => o.toLinkedObjectIdentifier())
      .where(o => !!o.key)
      .toArray();
  }

  async showTimeSpanEditDialog() {
    const dialog = this.commonComponents.getDialogs().getDateDurationSelectDialog();
    const range = await dialog.show({
      from: this.from,
      to: this.to,
      selectionObjects: this.selectionObjects,
      dialogTitle: "経過時間項目編集",
      fromTitle: "開始日時",
      toTitle: "終了日時",
      toCellString: this.toCellString,
    });
    if (!range) { return; }
    this.writePropertyWhenValid(s => {
      s.from = range.from;
      s.to = range.to;
    });
  }

  private toCellString(column: FormatObjectSelectorColumnTypes, row: ILinkedObjectSpecifiable): string {
    const formatObject = this.getFormatObjectEditable(row);
    switch (column) {
      case "key":
        return formatObject && formatObject.getIdentifiableName()
          ? formatObject.getIdentifiableName()
          : row.key;
      case "id":
        return row.id ? row.id.toString() : "";
      default:
        return "";
    }
  }

  private getFormatObjectEditable(row: ILinkedObjectSpecifiable): IFormatObjectEditable {
    return Enumerable.from(this.commonComponents.currentPage.getObjects())
      .firstOrDefault(o => {
        const linkedObject = o.toLinkedObjectIdentifier();
        return linkedObject.type === row.type &&
          linkedObject.id === row.id &&
          linkedObject.key === row.key &&
          linkedObject.isDate === row.isDate;
      });
  }

  kindOptions: StandardOption<TimeSpanKinds>[] = [
    new StandardOption<TimeSpanKinds>("日時分", TimeSpanKinds.DayHourMinute),
    new StandardOption<TimeSpanKinds>("時分", TimeSpanKinds.HourMinute),
    new StandardOption<TimeSpanKinds>("分", TimeSpanKinds.Minute),
  ];
}
